import * as React from "react";
import { merge, $ } from "glamor";
import { theme } from "styles/theme";
import { formatMessage } from "lib/globalize-util";
import { TextField } from "@material-ui/core";
import { Close, ExpandLess, ExpandMore } from "@material-ui/icons";
import {
    SizesField,
    isUnitsPerPackInvalid,
    isShippingWeightInvalid,
    FIELD_PREFIX,
    ProductField,
} from "./product-edit-modal";
import { trimKeyPrefixString } from "./helpers";
import { has } from "lodash";

interface ISchemaFields {
    size_fields: any[];
}

interface IProps {
    index: number;
    // TODO: UNUSED
    id: string;
    onMove: (dragIndex: number, hoverIndex: number) => (e: any) => void;
    updateSizesField: (idx: number, field: SizesField) => (e: any) => void;
    sizeValue: string;
    unitsPerPackValue: number;
    shippingWeightValue: number;
    schemaFields: ISchemaFields;
    size: any;
    handleDeleteSize: (idx: number) => (e: any) => void;
    length: number;
    sizeGroup: string;
    errorResponseObj: any;
}

const SizeRow: React.FC<IProps> = (props) => {
    const {
        index,
        onMove,
        updateSizesField,
        sizeValue,
        unitsPerPackValue,
        shippingWeightValue,
        schemaFields,
        size,
        handleDeleteSize,
        length,
        sizeGroup,
        errorResponseObj,
    } = props;

    // TODO: DnD arrange
    // const ref = React.useRef<HTMLDivElement>(null);

    // const [, drop] = useDrop({
    //     accept: ItemTypes.SizeRow,
    //     hover(item: DragItem, monitor: DropTargetMonitor) {
    //         if (!ref.current) {
    //             return;
    //         }
    //         const dragIndex = item.index;
    //         const hoverIndex = index;

    //         if (dragIndex === hoverIndex) {
    //             return;
    //         }

    //         const hoverBoundingRect = ref.current?.getBoundingClientRect();
    //         const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    //         const clientOffset = monitor.getClientOffset();
    //         const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    //         if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
    //             return;
    //         }

    //         if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
    //             return;
    //         }

    //         onMove(dragIndex, hoverIndex);

    //         item.index = hoverIndex;
    //     },
    // });

    // const [{ isDragging }, drag, preview] = useDrag({
    //     item: { type: ItemTypes.SizeRow, id, index },
    //     collect: (monitor) => ({
    //         isDragging: !!monitor.isDragging(),
    //     }),
    // });

    const styles = React.useMemo(() => {
        return merge(
            {
                display: "flex",
                alignItems: "center",
                flexFlow: "row nowrap",
                marginBottom: "8px",
                padding: "8px",
                ":nth-child(even)": {
                    background: theme.palette.lightestGrey,
                },
            },
            $(" .dragHandler, .sizesDelete", {
                display: "flex",
                alignItems: "center",
                padding: "4px",
            }),
            $(" .sortCarets", {
                display: "flex",
                width: "42px",
            }),
            $(" .sortCarets div", {
                cursor: "pointer",
            }),
            $(" .fieldsWrapper", {
                display: "flex",
                flexFlow: "row wrap",
                margin: "0 4px",
                flex: 1,
            }),
            $(" .MuiSvgIcon-root", {
                fontSize: "2rem",
            }),
            $(" .sizeGroup", {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: "8px",
                "& span": {
                    fontWeight: "bold",
                    marginLeft: "4px",
                },
            }),
            $(" .sizesDelete", {
                cursor: "pointer",
            }),
        );
    }, []);

    // drag(drop(ref));

    return (
        <div {...styles}>
            {/* <div ref={ref} className="dragHandler">
                <DragHandle />
            </div> */}
            {length > 1 && (
                <div className="sortCarets">
                    {index > 0 && (
                        <div onClick={onMove(index, index - 1)}>
                            <ExpandLess />
                        </div>
                    )}
                    {index !== length - 1 && (
                        <div onClick={onMove(index, index + 1)}>
                            <ExpandMore />
                        </div>
                    )}
                </div>
            )}
            <div className="fieldsWrapper">
                <TextField
                    label={`${formatMessage("Size")}: *`}
                    fullWidth
                    type="text"
                    onBlur={updateSizesField(index, SizesField.Size)}
                    defaultValue={sizeValue}
                    variant="outlined"
                    error={
                        !sizeValue ||
                        has(
                            errorResponseObj,
                            `${trimKeyPrefixString(ProductField.Sizes, FIELD_PREFIX)}.${index}.${trimKeyPrefixString(
                                SizesField.Size,
                                FIELD_PREFIX,
                            )}`,
                        )
                    }
                />
                {schemaFields.size_fields.map((field) => {
                    const key = field.key?.split(".")?.[1];
                    return (
                        <TextField
                            key={key}
                            label={`${field.name}:${field.required ? " *" : ""}`}
                            fullWidth
                            type="text"
                            onBlur={updateSizesField(index, key)}
                            defaultValue={size[key] ?? field.details.default_value ?? ""}
                            variant="outlined"
                            error={has(
                                errorResponseObj,
                                `${trimKeyPrefixString(ProductField.Sizes, FIELD_PREFIX)}.${index}.${key}`,
                            )}
                        />
                    );
                })}
                <TextField
                    label={`${formatMessage("Units per Pack:")}`}
                    fullWidth
                    type="text"
                    onBlur={updateSizesField(index, SizesField.UnitsPerPack)}
                    defaultValue={unitsPerPackValue}
                    variant="outlined"
                    error={
                        isUnitsPerPackInvalid(unitsPerPackValue) ||
                        has(
                            errorResponseObj,
                            `${trimKeyPrefixString(ProductField.Sizes, FIELD_PREFIX)}.${index}.${trimKeyPrefixString(
                                SizesField.UnitsPerPack,
                                FIELD_PREFIX,
                            )}`,
                        )
                    }
                />
                <TextField
                    label={`${formatMessage("Shipping Weight:")}`}
                    fullWidth
                    type="text"
                    onBlur={updateSizesField(index, SizesField.ShippingWeight)}
                    defaultValue={shippingWeightValue}
                    variant="outlined"
                    error={
                        isShippingWeightInvalid(shippingWeightValue) ||
                        has(
                            errorResponseObj,
                            `${trimKeyPrefixString(ProductField.Sizes, FIELD_PREFIX)}.${index}.${trimKeyPrefixString(
                                SizesField.ShippingWeight,
                                FIELD_PREFIX,
                            )}`,
                        )
                    }
                />
                {sizeGroup && (
                    <div className="sizeGroup">
                        {formatMessage("Size Group")}:<span> {sizeGroup}</span>
                    </div>
                )}
            </div>
            <div className="sizesDelete" onClick={handleDeleteSize(index)}>
                <Close />
            </div>
        </div>
    );
};

export default SizeRow;
